import React from 'react';

import { FormattedMessage } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import AppIcon from '@atlaskit/icon/core/app';
import { Box, Stack, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { messages } from './messages';

const styles = cssMap({
	iconBadge: {
		alignItems: 'center',
		backgroundColor: token('color.background.neutral'),
		borderRadius: token('radius.full'),
		display: 'flex',
		height: '32px',
		justifyContent: 'center',
		width: '32px',
	},
});

/**
 * Empty state shown inside the Hub Connect extension when no Connect
 * renderer is injected for the slot — typically because the tenant has
 * no installed Connect module matching `jsmHubPortalHeader` /
 * `jsmHubPortalFooter`.
 */
export const HubConnectEmptyState = (): React.JSX.Element => (
	<Box
		paddingBlock="space.500"
		paddingInline="space.300"
		testId="hub-connect-extension.empty-state"
	>
		<Stack space="space.150" alignInline="center">
			<Box xcss={styles.iconBadge}>
				<AppIcon label="" color={token('color.icon.subtle')} />
			</Box>
			<Text as="strong" weight="bold">
				<FormattedMessage {...messages.emptyStateTitle} />
			</Text>
			<Text color="color.text.subtle" align="center">
				<FormattedMessage {...messages.emptyStateDescription} />
			</Text>
		</Stack>
	</Box>
);
